import { styled } from '../../../styles/settings'

export const H5 = styled.h5`
  color: ${props => props.theme.colors.darkgray};
`

export const H4 = styled.h4`
  color: ${props => props.theme.colors.steam};
`
